import React from "react";
import Link from "next/link";
import {
  LandingSection,
  SectionHeader,
} from "./landing/landing-ui";

const paths = [
  {
    title: "Explore use cases",
    description:
      "See where agents, LLM apps, and automation typically land in operations-heavy businesses.",
    href: "/use-cases",
    cta: "Browse use cases",
  },
  {
    title: "Understand delivery",
    description:
      "From discovery through pilot and production handoff: how we structure work and ownership.",
    href: "/how-we-work",
    cta: "How we work",
  },
  {
    title: "Start a conversation",
    description:
      "Share the problem and systems involved. We will respond with clear next steps.",
    href: "/contact",
    cta: "Contact us",
  },
];

function NextSteps() {
  return (
    <LandingSection>
      <SectionHeader
        title="Where to go next"
        lead="Pick the path that matches where you are: exploring problems, evaluating delivery, or ready to talk scope."
      />
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {paths.map((item) => (
          <Link
            key={item.href}
            href={item.href}
            className="group block border-t border-line pt-5 no-underline transition-colors"
          >
            <h3 className="text-lg font-semibold text-ink transition-colors group-hover:text-[#1c8c80]">
              {item.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-ink-muted">
              {item.description}
            </p>
            <span className="mt-4 inline-block text-sm font-semibold text-[#1c8c80]">
              {item.cta} →
            </span>
          </Link>
        ))}
      </div>
    </LandingSection>
  );
}

export default NextSteps;
